import { CurrencySymbol } from "@repo/components";
import { formProductOptionsString } from "@repo/lib/helpers";
import { Media } from "@repo/ui";
import cx from "classnames";

const LineItem = ({ item, isShippable }) => {
  const productOptions = formProductOptionsString(item);

  const itemClasses = cx(
    "flex items-center border-b py-4 text-sm last:border-none",
    {
      "border-[#C62828]": !isShippable,
      "border-supportiveDarkGray": isShippable,
    }
  );

  return (
    <div key={item?.id} className={itemClasses}>
      <div className="relative">
        <Media
          src={item.image?.imageURI}
          alt={item?.name}
          width={72}
          height={72}
          className="mx-auto"
        />
      </div>
      <div className="max-w-44 ps-5 md:max-w-64">
        <p className="pb-1">{item?.name}</p>
        {productOptions && (
          <span className="text-supportiveGray4 text-sm font-medium">
            {productOptions}
          </span>
        )}
        <p className="pb-1 font-semibold">
          <CurrencySymbol
            value={item?.formattedSalePrice}
            variant="smallSpecial"
          />
        </p>
      </div>
      <p className="ms-auto pb-1">
        X {item?.quantity || item?.originalQuantity}
      </p>
    </div>
  );
};

export default LineItem;
